import Auth from './Auth'

const AuthModule = {
  init() {},
}

// export const Auth from './Auth'

export { Auth }

export default AuthModule
